import { useCallback, useEffect, useRef } from "react";

export function useMessage(ref: React.RefObject<HTMLIFrameElement>, callback: (error: Error | null, data?: object) => void) {
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    const onMessageHandler = useCallback(
        (event: MessageEvent<any>) => {
            if (event.origin.indexOf('finn.no') > -1 || event.origin.indexOf('localhost') > -1) {
                const validMessage = event.source === ref.current?.contentWindow;
                const data = typeof event.data === 'string' ? JSON.parse(event.data) : null;
                if (validMessage && data) {
                    savedCallback.current(null, data);
                }

            }
        },
        [ref]
    );
    useEffect(() => {
        window.addEventListener('message', onMessageHandler);
        return () => window.removeEventListener('message', onMessageHandler);
    }, [onMessageHandler]);

}